module.exports = __webpack_public_path__ + "img/icon_facebook.52bc8a6d.svg";